import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useRoutePlanningTheme } from './hook';

export const withRoutePlanningTheme =
  <P extends Record<string, any>>(Component: React.FC<P>): React.FC<P> =>
  (props: P) => {
    const { theme } = useRoutePlanningTheme();

    return (
      <ThemeProvider theme={theme as any}>
        <Component {...props} />
      </ThemeProvider>
    );
  };

export const withOldRem =
  <P extends Record<string, any>>(Component: React.FC<P>): React.FC<P> =>
  (props: P) => {
    return (
      <div className="old-rem">
        <Component {...props} />
      </div>
    );
  };
